import { render } from "./FacetView.vue?vue&type=template&id=742a7247"
import script from "./FacetView.vue?vue&type=script&lang=js"
export * from "./FacetView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jeongyunl/Documents/GitHub/datamap-search/vue-for-django/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__